import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { UserPlus, Copy, Mail, Share2, Users } from "lucide-react";

export function InviteRepDialog({ tournament, onClose }) {
  const [team, setTeam] = useState(null);
  const [withTeam, setWithTeam] = useState(true);
  useEffect(() => { if (tournament) api.get("/teams/me").then((r) => setTeam(r.data.is_manager ? r.data.team : null)).catch(() => setTeam(null)); }, [tournament]);
  if (!tournament) return null;

  const link = `${window.location.origin}/app/tournaments?join=${tournament.id}${withTeam && team ? `&team=${team.code}` : ""}`;
  const text = `You're invited to "${tournament.name}" on Pitch Craft — ${tournament.format === "bracket" ? "a knockout bracket" : "a score cup"} against the ${tournament.persona_title}.${withTeam && team ? ` You'll join our team "${team.name}" too.` : ""}\n\nJoin here: ${link}`;
  const copy = async () => { await navigator.clipboard.writeText(link); toast.success("Invite link copied"); };
  const email = () => { window.location.href = `mailto:?subject=${encodeURIComponent(`Join me in ${tournament.name} on Pitch Craft`)}&body=${encodeURIComponent(text)}`; };
  const share = async () => { if (navigator.share) { try { await navigator.share({ title: tournament.name, text, url: link }); } catch { /* cancelled */ } } else copy(); };

  return (
    <Dialog open={!!tournament} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="sm:max-w-md bg-white" data-testid="invite-rep-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><UserPlus className="w-5 h-5 text-amber-600" /> Invite a rep to {tournament.name}</DialogTitle>
          <DialogDescription>Anyone who opens this link is entered into the tournament automatically (they'll sign up or log in first if needed).</DialogDescription>
        </DialogHeader>
        {team && (
          <label className="flex items-start gap-3 rounded-xl border border-slate-200 bg-slate-50 p-3 cursor-pointer" data-testid="invite-with-team">
            <input type="checkbox" checked={withTeam} onChange={(e) => setWithTeam(e.target.checked)} className="mt-1 accent-emerald-600" />
            <span className="text-sm text-slate-700"><Users className="w-3.5 h-3.5 inline mr-1 text-emerald-600" />Also add them to <strong>{team.name}</strong> (code {team.code}) so they show up in your Manager hub.</span>
          </label>
        )}
        <div className="flex gap-2">
          <input readOnly value={link} className="flex-1 min-w-0 h-10 rounded-xl border border-slate-200 bg-slate-50 px-3 text-xs font-mono text-slate-700" data-testid="invite-rep-link" />
          <Button size="sm" onClick={copy} className="h-10 rounded-xl bg-slate-900 hover:bg-slate-800 text-white" data-testid="invite-rep-copy"><Copy className="w-4 h-4" /></Button>
        </div>
        <div className="grid grid-cols-2 gap-2">
          <Button onClick={email} variant="outline" className="rounded-xl h-11" data-testid="invite-rep-email"><Mail className="w-4 h-4 mr-2" /> Email invite</Button>
          <Button onClick={share} className="rounded-xl h-11 bg-amber-500 hover:bg-amber-600 text-black font-bold" data-testid="invite-rep-share"><Share2 className="w-4 h-4 mr-2" /> Share…</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
